import { articleApi, companyApi, CompanyVo } from '@/axios/company';
import styles from './index.module.less';
import { Button, Flex, Typography } from 'antd';
import { useState } from 'react';
import { openCompanyInformationModal, openEditCompetitorModal } from '../Article';
import { useRequest } from 'ahooks';
import AccessButton from '@/components/AccessButton';
const { Paragraph, Text } = Typography;
const CompanyWebsite = ({
  companyInfo,
  refreshCompanyInfo,
}: {
  companyInfo?: CompanyVo;
  refreshCompanyInfo?: () => void;
}) => {
  return (
    <div className={styles.sections}>
      <div className={styles.section}>
        <Flex vertical gap={20}>
          <div className={styles.word_type}>
            企业官网:
            {companyInfo?.officialWebsite && (
              <a href={companyInfo?.officialWebsite} target="_blank" rel="noreferrer">
                {companyInfo?.officialWebsite}
              </a>
            )}
          </div>
        </Flex>
        <AccessButton permission={['company:official_site:edit']}>
          <Button
            type="primary"
            onClick={() => {
              openCompanyInformationModal(
                {
                  content: companyInfo?.officialWebsite || '',
                  companyId: companyInfo?.companyId || '',
                  propKey: 'officialWebsite',
                },
                {
                  width: 1000,
                  title: '编辑企业官网',
                },
                () => {
                  refreshCompanyInfo?.();
                }
              );
            }}
          >
            编辑企业官网
          </Button>
        </AccessButton>
      </div>
    </div>
  );
};
export default CompanyWebsite;
